import productModal from './product-modal';

function initProductCards() {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        addToCartForm: '[data-product-card-form]',
        addToCartButton: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        variantRadio: 'input[name="id"][type="radio"]',
        selectedVariantRadio: 'input[name="id"][type="radio"]:checked',
        selectedVariantDefault: '[name="id"]',
        smallCardModalTrigger: '[data-product-modal-trigger]',
      };

      this.classes = {
        isAdding: 'is-adding',
      };

      this.addToCartForm = this.querySelector(this.selectors.addToCartForm);
      this.addToCartButton = this.querySelector(this.selectors.addToCartButton);
      this.addToCartText = this.querySelector(this.selectors.addToCartText);
      this.variantRadios = this.querySelectorAll(this.selectors.variantRadio);
      this.productModalTrigger = this.querySelector(this.selectors.smallCardModalTrigger);
      this.productModal = this.querySelector(this.selectors.smallCardModal);

      // Initialization
      if (this.productModalTrigger) {
        productModal();
      } else {
        this.initForm();
      }
    }

    addToCartCallback(selectedVariant) {
      if (this.addToCartButton && this.addToCartText) {
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartText.innerText = window.theme.strings.addedToCart;

        setTimeout(() => {
          this.addToCartText.innerText = window.theme.strings.addToCart;
        }, 2000);
      } else if (selectedVariant) {
        setTimeout(() => {
          selectedVariant.classList.remove(this.classes.isAdding);
          selectedVariant.checked = false;
        }, 2000);
      }
    }

    initForm() {
      if (!this.addToCartForm) return;
      this.addToCartForm.addEventListener('submit', this.onFormSubmit.bind(this));

      this.variantRadios.forEach((radio) => {
        radio.addEventListener('click', () => {
          this.onFormSubmit();
        });
      });
    }

    onFormSubmit(event) {
      const selectedVariant =
        this.querySelector(this.selectors.selectedVariantRadio) ??
        this.querySelector(this.selectors.selectedVariantDefault);

      if (!selectedVariant) return;

      if (event) {
        event.preventDefault();
      }

      // Prevent multiple form submissions
      if (this.addToCartButton) {
        this.addToCartButton.setAttribute('disabled', '');
      } else {
        selectedVariant.classList.add(this.classes.isAdding);
      }

      const compareAtPrice = selectedVariant.dataset.variantCompare ?? null;
      window.sideCart.handleAddToCartEvent(
        {
          id: parseInt(selectedVariant.value, 10),
          quantity: 1,
          ...(compareAtPrice && {
            properties: {
              _compare_at_price: compareAtPrice,
            },
          }),
        },
        true,
        this.addToCartCallback.bind(this, selectedVariant)
      );
    }
  }

  customElements.define('product-card', ProductCard);
}

export default initProductCards;
